<template>
  <div>
    <!-- <div class="justify-end mb-5 d-flex">
      <v-btn elevation="0" color="success" class="ml-3" @click="dialog = true"
        ><v-icon left>mdi-plus</v-icon>เพิ่มผู้ค้า</v-btn
      >
    </div> -->
    <div class="d-flex align-center">
      <slot></slot>

      <FormCustomer v-model="dialog" event="create"></FormCustomer>
    </div>
  </div>
</template>

<script>
import FormCustomer from "./FormCustomer";
export default {
  components: { FormCustomer },
  name: "SearchCustomer",
  created() {},
  computed: {},
  data() {
    return {
      dialog: false,
      searchValue: "",
    };
  },
  watch: {},
  props: {
    search: String,
  },
  methods: {
    // search() {
    //   this.$store.dispatch("customer/searchCustomer", {
    //     search: this.searchValue,
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped></style>
